import React from 'react';
import { Link } from 'react-router-dom';
import {
  Activity,
  ArrowRight,
  Atom,
  Baby,
  Bone,
  Brain,
  Droplet,
  Droplets,
  Dumbbell,
  Eye,
  Flower,
  Flower2,
  Flame,
  GlassWater,
  Leaf,
  Milk,
  Moon,
  Shield,
  ShieldCheck,
  Sparkles,
  Sprout,
  Stethoscope,
  Sun,
  Zap,
} from 'lucide-react';
import { CATEGORIES } from '../data/mock';

const ICONS = {
  Activity,
  Atom,
  Baby,
  Bone,
  Brain,
  Droplet,
  Droplets,
  Dumbbell,
  Eye,
  Flame,
  Flower,
  Flower2,
  GlassWater,
  Leaf,
  Milk,
  Moon,
  Shield,
  ShieldCheck,
  Sparkles,
  Sprout,
  Stethoscope,
  Sun,
  Zap,
};

const Tile = ({ c, idx }) => {
  const Icon = ICONS[c.icon] || Sparkles;
  const palettes = [
    { bg: 'bg-[#e8f5ec]', ring: 'ring-[var(--msa-green)]/15', text: 'text-[var(--msa-green-dark)]' },
    { bg: 'bg-[#e7f1fb]', ring: 'ring-[var(--msa-blue)]/15', text: 'text-[var(--msa-blue-dark)]' },
    { bg: 'bg-[#fff4e0]', ring: 'ring-amber-500/15', text: 'text-amber-700' },
    { bg: 'bg-[#f3eafd]', ring: 'ring-purple-500/15', text: 'text-purple-700' },
  ];
  const p = palettes[idx % palettes.length];
  return (
    <Link to={`/catalog/${c.slug}`} className="group flex flex-col items-center text-center">
      <div className={`relative w-[88px] h-[88px] sm:w-[104px] sm:h-[104px] rounded-3xl ${p.bg} ring-1 ${p.ring} grid place-items-center transition-transform duration-300 group-hover:-translate-y-1`}> 
        <Icon className={`w-9 h-9 sm:w-10 sm:h-10 ${p.text}`} strokeWidth={1.6} />
        <span className="absolute -top-1.5 -right-1.5 w-5 h-5 rounded-full bg-white border border-[var(--msa-line)] grid place-items-center text-[10px] font-bold text-[var(--msa-ink-soft)] group-hover:text-[var(--msa-green-dark)]">+</span>
      </div>
      <div className="mt-3 text-[12.5px] sm:text-[13.5px] font-semibold text-[var(--msa-ink)] leading-tight max-w-[120px] group-hover:text-[var(--msa-green-dark)] transition-colors">{c.name}</div>
    </Link>
  );
};

const Categories = () => {
  return (
    <section className="py-12 sm:py-16">
      <div className="max-w-[1320px] mx-auto px-4 sm:px-6">
        <div className="flex items-end justify-between mb-6 sm:mb-8">
          <div>
            <div className="text-[11px] uppercase tracking-[0.2em] font-bold text-[var(--msa-green-dark)] mb-2">Навігація</div>
            <h2 className="font-display text-[24px] sm:text-[32px] font-bold leading-tight">Популярні категорії</h2>
          </div>
            <Link to="/catalog" className="hidden sm:inline-flex items-center gap-1 text-sm font-semibold text-[var(--msa-ink-soft)] hover:text-[var(--msa-green-dark)] transition-colors">Дивитись всі <ArrowRight className="w-4 h-4" /></Link>
        </div>
        <div className="grid grid-cols-3 sm:grid-cols-6 gap-x-4 gap-y-6">
          {CATEGORIES.filter(c => c.slug !== 'all').slice(0, 6).map((c, idx) => (
            <Tile key={c.slug} c={c} idx={idx} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Categories;
